import { render, staticRenderFns } from "./editOrder.vue?vue&type=template&id=5153b27b&"
import script from "./editOrder.vue?vue&type=script&lang=js&"
export * from "./editOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports